import React from "react";

const ConfirmDeleteModal = ({ open, onClose, onConfirm, user }) => {
  if (!open) return null;

  return (
    <div className="bg-black/20 fixed inset-0 z-50 flex items-center justify-center px-4 backdrop-blur-sm">
      <div className="w-full max-w-md rounded-2xl border border-gray-100 bg-white/95 p-6 text-center shadow-2xl sm:p-8">
        <h2 className="mb-4 text-base font-semibold text-gray-800 sm:text-lg">
          Do you really want to delete{" "}
          <span className="text-[#c51369] ">
            {user?.firstName
              ? `${user.firstName} ${user.lastName}`
              : user?.panName || "this user"}
          </span>
          ’s KYC?
        </h2>

        <div className="mt-4 flex flex-col justify-center gap-4 sm:flex-row">
          <button
            onClick={onClose}
            className="w-full rounded-lg bg-gray-100 px-4 py-2 text-gray-700 transition hover:bg-gray-200 sm:w-auto"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="w-full rounded-lg bg-red-500 px-4 py-2 text-white transition hover:bg-red-600 sm:w-auto"
          >
            Delete It
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;
